import React, { Component } from 'react';

class NewDropdownNestedContent extends Component {
  render() {
    const { links = [] } = this.props || {};
    if (links.length === 0) return null;

    return (
      <div
        className="dropdownNestedContent"
      >
        <div className="borderRoundTop" />
        <ul className="resetUlStyles dropdownContent">
          {
            links.map(({ text, url, label }) => (
              <li key={text || label}>
                <a
                  className="textIndentEfect"
                  href={url}
                >
                  {text || label}
                </a>
              </li>
            ))
          }
        </ul>
        <div className="borderRoundBottom" />
      </div>
    );
  }
}

export default NewDropdownNestedContent;
